import React from 'react'
import { Button, Card, Col, Container, Dropdown, Image, Row, DropdownButton } from 'react-bootstrap'
import MasterLayout from "../../components/Layout/MasterLayout";
import joinImage from "../../assets/images/join.svg";
import { Typewriter } from "react-simple-typewriter";

const approveDecline = () => {
  return (
    <MasterLayout>
      {/* Begin: Home Banner */}
      <section className="home-banner-wrap">
        <Container>
          {/* <Row>
            <div className="col-md-12"> */}
              <div className="banner-caption-wrap">
                <h2 className="banner-sub-caption">
                  Welcome to Candidate Portal
                </h2>

                <h1 className="banner-main-caption">
                  {/* Offer Approval */}
                  <strong>
                    {/* Offer Approval */}
                    <Typewriter
                      words={["Offer Approval"]}
                      loop={1}
                      typeSpeed={130}
                      deleteSpeed={50}
                      delaySpeed={1000}
                    />
                  </strong>
                </h1>
              </div>
            {/* </div>
          </Row> */}
        </Container>
      </section>
      {/* Ends: Home Banner */}
      <section className="offer-approval" id="offer-approval">
        <Container>
          {/* <h2>Offer</h2> */}
          <Card className="offer-box-wrap">
            <div class="card-body">
              <ul className="list-unstyled content-wrapper">
                <li className="candidate-name">
                  <h2 className="m-0 profile-name">James C. Stewart</h2>
                </li>
                <li className="d-flex justify-content-between">
                  <div className="mt-2 single-row-wrap">
                    <span class="bx bx-envelope"></span>
                    <div className="user-data">
                      <small>Email</small>
                      <h6 className="mt-1 text-title">loremipsum@gmail.com</h6>
                    </div>
                  </div>
                  <div className="mt-2 single-row-wrap">
                    <span class="bx bx-phone"></span>
                    <div className="user-data">
                      <small>Phone</small>
                      <h6 className="mt-1 text-title">1234567899</h6>
                    </div>
                  </div>
                  <div className="mt-2 single-row-wrap">
                    <span class="bx bx-map"></span>
                    <div className="user-data">
                      <small>Address</small>
                      <h6 className="mt-1 text-title">The Palazzo House, 15-31, KPHB 6th Phase Road, Hyderabad Telangana</h6>
                    </div>
                  </div>
                </li>
                <li className="d-flex justify-content-between">
                  <div className="single-row-wrap">
                    <span class="bx bx-user"></span>
                    <div className="user-data">
                      <small>Designation</small>
                      <h6 className="mt-1 text-title">
                        Software Engineer Level 1
                      </h6>
                    </div>
                  </div>
                  <div className="single-row-wrap">
                    <span class="bx bx-coin-stack"></span>
                    <div className="user-data">
                      <small>Package</small>
                      <h6 className="mt-1 text-title">
                        12 lakh per annum
                      </h6>
                    </div>
                  </div>
                  <div className="single-row-wrap">
                    <span class="bx bx-file"></span>
                    <div className="user-data">
                      <small>Document Update Completion Date</small>
                      <h6 className="mt-1 text-title">
                        05 Oct 2022
                      </h6>
                    </div>
                  </div>
                </li>
                <li className="d-flex justify-content-between">
                  <div className="single-row-wrap">
                    <span class="bx bx-calendar"></span>
                    <div className="user-data">
                      <small>Offer Date</small>
                      <h6 className="mt-1 text-title">
                        29 Sept 2022
                      </h6>
                    </div>
                  </div>
                  <div className="single-row-wrap">
                    <span class="bx bx-calendar-event"></span>
                    <div className="user-data">
                      <small>Offer Acceptance Date</small>
                      <h6 className="mt-1 text-title">
                        30 Sept 2022
                      </h6>
                    </div>
                  </div>
                  <div className="single-row-wrap">
                    <span class="bx bx-calendar-check"></span>
                    <div className="user-data">
                      <small>Accepted Joining Date</small>
                      <h6 className="mt-1 text-title">
                        01 Oct 2022
                      </h6>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </Card>
          <div className="offer-buttons d-flex justify-content-center mt-4">
            <button className="btn btn-primary">Accept</button>
            <button className="btn btn-outline-danger">Decline</button>
          </div>
        </Container>
      </section>
    </MasterLayout>
  )
}

export default approveDecline